var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
var SvgFolderBlack = function (props) { return (_jsxs("svg", __assign({ width: 42, height: 30, viewBox: "0 0 42 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("path", { d: "M34.672 27.148v.003c0 .097-.01.195-.03.29l-.12.398c-.258.567-.826.93-1.45.927H2.102a1.61 1.61 0 0 1-1.557-1.228l-.002-.007a1.392 1.392 0 0 1-.044-.373V1.804A1.301 1.301 0 0 1 1.8.5h9.214c.466.002.897.248 1.135.648l2.176 3.77.145.25H33.38a1.299 1.299 0 0 1 1.292 1.305V27.148Z", fill: "#000", stroke: "#000" }), _jsx("path", { d: "m5.544 12.367-4.667 14A2 2 0 0 0 2.775 29h32.287a2 2 0 0 0 1.914-1.42l4.242-14A2 2 0 0 0 39.304 11H7.442a2 2 0 0 0-1.898 1.367Z", fill: "#fff", stroke: "#000" })] }))); };
var Memo = memo(SvgFolderBlack);
export default Memo;
//# sourceMappingURL=FolderBlack.js.map